<script setup lang="ts">
import PageLayout from "./components/PageLayout.vue";
</script>

<template>
  <PageLayout>
    <RouterView />
  </PageLayout>
</template>
